/*
|--------------------------------------------------------------------------
| DEVICE
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
 __gh__webApp.device = {

	"isMobile": function() {
		var width = window.innerWidth;
		if (width <= 992){
			return true;
		}
		return false;
	},
	
	"isTablet": function() {
		var width = window.innerWidth;
		if (width <= 768 && width >= 480){
			return true;
		}
		return false;
	},

	"isPhone": function() {
		var width = window.innerWidth;
		if (width <= 768){
			return true;
		}
		return false;
	}
};